import { Popup, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { ConfirmModal } from 'react-lib/dist/components-es';
import { SHARE_DATA_VIEW } from '../../../../../constants';

type Props = {
  selectedView: any;
  setSelectedView: (arg0: boolean) => void;
  actions: any;
  entityType: string;
};

const LockUnlockButtonGroup = ({ selectedView, setSelectedView, actions, entityType }: Props) => {
  const { t } = useTranslation();
  const loc = selectedView.locked;
  const [locked, setLocked] = useState(loc);
  useEffect(() => {
    setLocked(loc);
  }, [loc]);

  const disableLockUnlock = JSON.stringify(selectedView.deletableview) !== 'true';
  const disableDelete = JSON.stringify(selectedView.deletableview) !== 'true' || loc;

  const confirmHandle = () => {
    const { href } = window.location;
    window.history.replaceState('', '', href.substr(0, href.indexOf(SHARE_DATA_VIEW)));
    actions.deleteDataView(selectedView.value, entityType);
  };

  const onUnlockButton = () => {
    actions.lockUnlockDataView(selectedView.value, entityType);
    setSelectedView({ ...selectedView, locked: false });
    setLocked(false);
  };
  const onLockButton = () => {
    actions.lockUnlockDataView(selectedView.value, entityType);
    setSelectedView({ ...selectedView, locked: true });
    setLocked(true);
  };

  return (
    <>
      {locked ? (
        <Popup
          key="unlockDataViewToolTip"
          trigger={
            <Button
              icon="lock"
              type="button"
              onClick={() => {
                onUnlockButton();
              }}
              disabled={disableLockUnlock}
              className="mini"
            />
          }
          size="mini"
          content={t('overview.page.data.view.lock.tooltip')}
          position="top left"
        />
      ) : (
        <Popup
          key="lockDataViewToolTip"
          trigger={
            <Button
              icon="lock open"
              type="button"
              on="click"
              position="left"
              onClick={() => {
                onLockButton();
              }}
              disabled={disableLockUnlock}
              className="mini"
            />
          }
          size="mini"
          content={t('overview.page.data.view.unlock.tooltip')}
          position="top left"
        />
      )}
      <ConfirmModal
        buttonProps={{
          color: 'red',
          icon: 'trash alternate',
          disabled: disableDelete,
          size: 'mini',
        }}
        key="deleteDataViewButtonKey"
        header={t(`confirm.modal.delete.dataView.title`)}
        content={t(`confirm.modal.delete.dataView.content`)}
        confirmFunction={() => {
          confirmHandle();
        }}
      />
    </>
  );
};

export default LockUnlockButtonGroup;
